const typography = {
    fontFamily: `"Roboto Mono", sans-serif`,
    fontSize: 11,
    fontWeightLight: 100,
    fontWeightRegular: 500,
    fontWeightMedium: 700,

    h1: {
        fontWeight: 700,
        fontSize: 45,
        letterSpacing: "-1px",
    },
    h2: {
        fontWeight: 800,
        fontSize: 29,
        letterSpacing: "-0.24px",
    },
    h3: {
        fontWeight: 700,
        fontSize: 24,
        letterSpacing: "-0.06px",
    },
    h4: {
        fontWeight: 500,
        fontSize: 20,
        letterSpacing: "-0.06px",
    },
    h5: {
        fontWeight: 500,
        fontSize: 16,
        letterSpacing: "-0.05px",
    },
    h6: {
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: "-0.05px",
    },
    overline: {
        fontWeight: 500,
    },
};

export default typography;
